module.exports = __webpack_public_path__ + "static/media/DK_4020Y.a7ae679f.jpg";